import { render, staticRenderFns } from "./ImportOrdImg.vue?vue&type=template&id=b465708a&"
import script from "./ImportOrdImg.vue?vue&type=script&lang=js&"
export * from "./ImportOrdImg.vue?vue&type=script&lang=js&"
import style0 from "./ImportOrdImg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports